const paperBoolean = true
export const routes = [
  {
    index: '-1',
    name: 'goods',
    title: '供应商商品库',
    path: 'goods',
    filePath: '/goods/index.vue',
    isIframe: false,
    // cityAuth: [ 5, 3 ], // [广州5] [成都3]
    subPathes: [
      {
        index: '/goods/store',
        name: 'store',
        title: '供应商商品库', // 供应商商品库
        path: 'store',
        filePath: '/goods/store.vue',
      },
      {
        index: '/goods/new/auditDetail',
        name: 'auditDetail',
        title: '审核详情', // 审核详情
        isHideAtMenu: true,
        path: 'auditDetail',
        filePath: '/goods/new/auditDetail.vue',
        isIframe: false,
      },
      {
        index: '/goods/new',
        name: 'goodsNew',
        title: '新增商品',
        path: 'new',
        filePath: '/goods/new.vue',
        isIframe: false,
      },
      {
        index: '/goods/new/meicaiStore',
        name: 'meicaiStore',
        title: '新增商品',
        path: 'meicaiStore',
        isHideAtMenu: true,
        filePath: '/goods/new/meicaiStore.vue',
        isIframe: false,
      },
      {
        index: '/goods/new/createProcess',
        name: 'createProcess',
        title: '新增商品|测试', // 商品创建流程
        path: 'createProcess',
        isHideAtMenu: true,
        filePath: '/goods/new/createProcess.vue',
        isIframe: false,
      },
      {
        index: '/goods/new/querySku',
        name: 'querySku',
        title: '查询sku',
        path: 'querySku',
        isHideAtMenu: true,
        filePath: '/goods/new/querySku.vue',
        isIframe: false,
      },
      {
        index: '/goods/cert',
        name: 'cert',
        title: '商品资质', // 商品资质
        path: 'cert',
        filePath: '/goods/cert.vue',
        isIframe: false,
      },
      // 新建商品
      {
        index: '/goods/new/goodsView',
        name: 'goodsView',
        title: '商品预览',
        path: 'goodsView',
        isHideAtMenu: true,
        filePath: '/goods/new/goodsView.vue',
        isIframe: false,
      },
      {
        index: '/goods/new/selectCategory',
        name: 'selectCategory',
        title: '商品大类选择',
        path: 'selectCategory',
        isHideAtMenu: true,
        filePath: '/goods/new/selectCategory.vue',
        isIframe: false,
      },
      {
        index: '/goods/new/submitResult',
        name: 'submitResult',
        title: '提交结果',
        path: 'submitResult',
        isHideAtMenu: true,
        filePath: '/goods/new/submitResult.vue',
        isIframe: false,
      },
      // 资质模块
      {
        index: '/goods/certProcess',
        name: 'certProcess',
        title: '资质修改',
        path: 'certProcess',
        isHideAtMenu: true,
        filePath: '/goods/cert/certProcess.vue',
        isIframe: false,
      },
      // 商品模块
      {
        index: '/goods/store/price',
        name: 'storePrice',
        title: '价格分析',
        path: 'storePrice',
        isHideAtMenu: true,
        filePath: '/goods/store/price.vue',
        isIframe: false,
      },
      {
        index: '/goods/store/goodsCertDetail',
        name: 'goodsCertDetail',
        title: '商品资质详情',
        path: 'goodsCertDetail',
        isHideAtMenu: true,
        filePath: '/goods/store/goodsCertDetail.vue',
        isIframe: false,
      },
      {
        index: '/goods/createSku',
        name: 'createSku',
        title: '自主建档',
        path: 'createSku',
        isHideAtMenu: true,
        filePath: '/goods/createSku/create.vue',
        isIframe: false,
      },
    ],
  },
  // {
  //   index: '12',
  //   name: 'package',
  //   title: '物资管理',
  //   path: 'package',
  //   filePath: '/package/index.vue',
  //   isIframe: false,
  //   // cityAuth: [ 5, 3 ], // [广州5] [成都3]
  //   subPathes: [
  //     {
  //       index: '/package/management',
  //       name: 'package',
  //       title: '包装物管理', // 供应商商品库
  //       path: 'package',
  //       filePath: '/package/management.vue'
  //     },
  //     {
  //       index: '/package/confirm',
  //       name: 'packageConfirm',
  //       title: '包装物确认', // 供应商商品库
  //       path: 'packageConfirm',
  //       filePath: '/package/confirm.vue'
  //     },
  //     {
  //       index: '/package/management/enter',
  //       name: 'packageManagementEnter',
  //       title: '包装物管理', // 供应商商品库
  //       path: 'packageManagementEnter',
  //       isHideAtMenu: true, // 不在左侧menu中显示
  //       filePath: '/package/entry.vue'
  //     },
  //     {
  //       index: '/package/management/return',
  //       name: 'packageManagementReturn',
  //       title: '包装物管理', // 供应商商品库
  //       path: 'packageManagementReturn',
  //       isHideAtMenu: true, // 不在左侧menu中显示
  //       filePath: '/package/return.vue'
  //     },
  //     {
  //       index: '/package/management/purchase',
  //       name: 'packageManagementPurchase',
  //       title: '包装物管理', // 供应商商品库
  //       path: 'packageManagementPurchase',
  //       isHideAtMenu: true, // 不在左侧menu中显示
  //       filePath: '/package/purchase.vue'
  //     }
  //   ]
  // },
  {
    index: '0',
    name: 'order',
    title: '订单信息',
    path: 'order',
    filePath: '/order/index.vue',
    isIframe: false,
    subPathes: [
      {
        index: '/order/notConfirmed',
        name: 'orderNotConfirmed',
        title: '待确认',
        path: 'notConfirmed',
        filePath: '/order/notConfirmed.vue',
        isIframe: false,
      },
      {
        index: '/order/preDeliverGoods',
        name: 'preDeliverGoods',
        title: '待预约',
        path: 'preDeliverGoods',
        filePath: '/order/preDeliverGoods/index.vue',
        isIframe: false,
      },
      {
        index: '/order/deliverGoods',
        name: 'deliverGoods',
        title: '已预约',
        path: 'deliverGoods',
        filePath: '/order/deliverGoods.vue',
        isIframe: false,
      },
      {
        index: '/order/detail',
        name: 'reserveDetail',
        title: '详情',
        path: 'reserveDetail',
        isHideAtMenu: true, // 不在左侧menu中显示
        filePath: '/order/reserveDetail.vue',
        isIframe: false,
      },
      {
        index: '/order/preDeliverGoods/receivePort',
        name: 'receivePort',
        title: '收货口',
        path: 'receivePort',
        isHideAtMenu: true, // 不在左侧menu中显示
        filePath: '/order/preDeliverGoods/receivePort.vue',
        isIframe: false,
      },
      {
        index: '/order/confirmStockYes',
        name: 'orderConfirmStockYes',
        title: '待入库',
        path: 'confirmStockYes',
        filePath: '/order/confirmStockYes.vue',
        isIframe: false,
      },
      {
        index: '/order/allReadyInstock',
        name: 'orderAllReadyInstock',
        title: '已入库',
        path: 'allReadyInstock',
        filePath: '/order/allReadyInstock.vue',
        isIframe: false,
      },
      {
        index: '/order/allReadyReturn',
        name: 'orderAllReadyReturn',
        title: '已退货',
        path: 'allReadyReturn',
        filePath: '/order/allReadyReturn.vue',
        isIframe: false,
      },
      {
        index: '/order/exceptionPurchaseOrder',
        name: 'orderExceptionPurchaseOrder',
        title: '异常订单',
        path: 'exceptionPurchaseOrder',
        filePath: '/order/exceptionPurchaseOrder.vue',
        isIframe: false,
      },
      {
        index: '/order/checkAndAcceptOrder',
        name: 'checkAndAcceptOrder',
        title: '入库验收单',
        serviceUnitIds: [4708885, 13884937, 4746569, 7829299, 66002438], // 是否为 武汉家家源贸易有限公司
        path: 'checkAndAcceptOrder',
        filePath: '/order/checkAndAcceptOrder.vue',
        isIframe: false,
      },
      // {
      //   index: '/order/placeOrder',
      //   name: 'orderPlaceOrder',
      //   title: '自主下单',
      //   path: 'placeOrder',
      //   filePath: '/order/placeOrder.vue',
      //   isIframe: false
      // },
    ],
  },
  {
    index: '0.1',
    name: 'contract',
    title: '合同管理',
    // whoHadAuth: [1], // 权限控制，谁具有权限看这个选项 ，whoHadAuth字段为undefined则所有人都能看
    path: 'contract',
    filePath: '/iframe/index.vue',
    isIframe: false,
    subPathes: [
      // {
      //   index: '0.1-0',
      //   name: 'contractMyContract',
      //   title: '我的合同(2020及之前)',
      //   path: 'contract',
      //   filePath: '/iframe/sub.vue',
      //   isIframe: true,
      //   iframeUrl: '/client.html#/list',
      //   iframeHost: 'ecpUrl'
      // },
      {
        index: '/contract/manage',
        name: 'contractManage',
        title: '我的合同',
        path: 'manage',
        filePath: '/contract/manage.vue',
        isIframe: false,
      },
      {
        index: '0.1-2',
        name: 'signImage',
        title: '我的印章',
        path: 'signImage',
        filePath: '/contract/signImage.vue',
        isIframe: false,
      },
      {
        index: '/contract2/sign',
        name: 'contractSign',
        title: '合同签署',
        path: 'sign',
        isHideAtMenu: true,
        filePath: '/contract/sign.vue',
        isIframe: false,
      },
      {
        index: '/contract/authorisation',
        name: 'contractAuthorisation',
        title: '授权管理',
        path: 'authorisation',
        filePath: '/contract/authorisation.vue',
        isIframe: false,
      },
    ],
  },
  {
    index: '0.2',
    name: 'certManage',
    title: '资质管理',
    path: 'certManage',

    filePath: '/certManage/index.vue',
    isIframe: false,
    iframeUrl: '',
    subPathes: [
      {
        index: '/certManage/qualificationTask',
        name: 'qualificationTask',
        title: '资质任务',
        path: 'qualificationTask',
        filePath: '/certManage/qualificationTask.vue',
        isIframe: false,
      },
      {
        index: '/certManage/detail',
        name: 'detail',
        path: 'detail',
        title: '我的资质',
        isIframe: 'false',
        filePath: '/certManage/detail.vue',
      },
      // {
      //   index: '/certManage/baseCert?status=1',
      //   name: 'baseCert',
      //   title: '我的资质',
      //   path: 'baseCert',
      //   query: {
      //     status: 1
      //   },
      //   filePath: '/certManage/base.vue',
      //   isIframe: false,
      //   iframeUrl: ''
      // },
      // {
      //   index: '/certManage/expandCert?status=2',
      //   name: 'expandCert',
      //   title: '我的证件',
      //   path: 'expandCert',
      //   query: {
      //     status: 3
      //   },
      //   filePath: '/certManage/expand.vue',
      //   isIframe: false,
      //   iframeUrl: ''
      // },
      {
        index: '/certManage/productCert?status=3',
        name: 'productCert',
        title: '商品资质',
        path: 'productCert',
        query: {
          status: 2,
        },
        filePath: '/certManage/product.vue',
        isIframe: false,
        iframeUrl: '',
      },
      {
        index: '/certManage/productCert/detail',
        name: 'productCertDetail',
        title: '商品资质',
        path: 'productCertDetail',
        isHideAtMenu: true, // 不在左侧menu中显示
        query: {
          status: 2,
        },
        filePath: '/certManage/detail/product.vue',
        isIframe: false,
        iframeUrl: '',
      },
      {
        index: '/certManage/productCert/detail',
        name: 'productCertRateDetail',
        path: 'productCertRateDetail',
        isHideAtMenu: true, // 不在左侧menu中显示
        filePath: '/certManage/detail/rate.vue',
        isIframe: false,
      },
    ],
  },
  {
    index: '1',
    name: 'distribution',
    title: '直送订单',
    path: 'price',
    filePath: '/directOrder/index.vue',
    isIframe: false,
    subPathes: [
      {
        index: '/price/confirm?status=21',
        name: 'confirm',
        title: '待出库',
        path: 'confirm',
        query: {
          status: 21,
        },
        filePath: '/directOrder/main.vue',
        isIframe: false,
      },
      {
        index: '/price/deliver?status=23',
        name: 'deliver',
        title: '配送中',
        path: 'deliver',
        query: {
          status: 23,
        },
        filePath: '/directOrder/sending1.vue',
        isIframe: false,
      },
      {
        index: '/price/deliverCode',
        name: 'deliverCode',
        title: '配送中',
        path: 'deliverCode',
        isHideAtMenu: true, // 不在左侧menu中显示
        filePath: '/directOrder/sending2.vue',
        isIframe: false,
      },
      {
        index: '/price/finish?status=24',
        name: 'finish',
        title: '已完成',
        path: 'finish',
        query: {
          status: 24,
        },
        filePath: '/directOrder/main.vue',
        isIframe: false,
      },
      {
        index: '/price/cancel?status=22',
        name: 'cancel',
        title: '已取消',
        path: 'cancel',
        query: {
          status: 22,
        },
        filePath: '/directOrder/main.vue',
        isIframe: false,
      },
      {
        index: '/price/confirm/confirm',
        name: '/price/confirm/confirm',
        title: '待出库',
        isHideAtMenu: true,
        path: '/price/confirm/confirm',
        filePath: '/directOrder/confirm',
        isIframe: false,
        isIframeUrl: '',
      },
    ],
  },
  {
    index: '2',
    name: 'price',
    title: '商品报价',
    path: 'price',
    filePath: '/price/index.vue',
    isIframe: false,
    subPathes: [
      {
        index: '/price/current',
        name: 'priceCurrent',
        title: '当前价格',
        path: 'current',
        filePath: '/price/priceCurrent.vue',
        isIframe: false,
      },
      {
        index: '/price/quote',
        name: 'priceQuote',
        title: '报价',
        path: 'quote',
        filePath: '/price/priceQuote.vue',
        isIframe: false,
      },
      // {
      //   index: '2-2',
      //   name: 'priceInvite',
      //   title: '邀约报价',
      //   path: 'invite',
      //   filePath: '/iframe/sub.vue',
      //   isIframe: true,
      //   iframeUrl: '/supplyPrice/invite'
      // }
    ],
  },
  {
    index: '3',
    name: 'billManage',
    title: '账单管理',
    path: 'billManage',
    filePath: '/billManage/index.vue',
    isIframe: false,
    subPathes: [
      {
        index: '3-0',
        name: 'billDetail',
        title: '详情',
        path: 'billDetail',
        query: {
          status: 1,
        },
        isHideAtMenu: true, // 不在左侧menu中显示
        filePath: '/billManage/detail.vue',
        isIframe: false,
      },
      {
        index: '/billManage/billAll',
        name: 'billAll',
        title: '全部',
        path: 'billAll',
        filePath: '/billManage/main.vue',
        isIframe: false,
      },
      {
        index: '/billManage/billConfirm?status=1',
        name: 'billConfirm',
        title: '待确认',
        path: 'billConfirm',
        query: {
          status: 1,
        },
        filePath: '/billManage/main.vue',
        isIframe: false,
      },
      {
        index: '/billManage/billObjection?status=3',
        name: 'billObjection',
        title: '异议账单',
        path: 'billObjection',
        query: {
          status: 3,
        },
        filePath: '/billManage/main.vue',
        isIframe: false,
      },
      {
        index: '/billManage/billWait?status=4',
        name: 'billWait',
        title: '待收款',
        path: 'billWait',
        query: {
          status: 4,
        },
        filePath: '/billManage/main.vue',
        isIframe: false,
      },
      {
        index: '/billManage/billAlready?status=5',
        name: 'billAlready',
        title: '已收款',
        path: 'billAlready',
        query: {
          status: 5,
        },
        filePath: '/billManage/main.vue',
        isIframe: false,
      },
    ],
  },
  {
    index: '4',
    name: 'orderManagement',
    title: '单据管理',
    path: 'orderManagement',
    filePath: '/adjustOrder/index.vue',
    isIframe: false,
    subPathes: [
      {
        index: '/orderManagement/serviceOrder',
        name: '/orderManagement/serviceOrder',
        title: '仓服务费',
        isHideAtMenu: false,
        path: '/orderManagement/serviceOrder',
        filePath: '/serviceOrder/index',
        isIframe: false,
        isIframeUrl: '',
        subPathes: [
          {
            index: 'processing',
            name: 'processing',
            title: '费用单详情',
            isHideAtMenu: true,
            path: 'processing',
            filePath: '/serviceOrder/processing.vue',
            isIframe: false,
            isIframeUrl: '',
          },
          {
            index: '/orderManagement/serviceOrder/tag',
            name: '/orderManagement/serviceOrder/tag',
            title: '费用单详情',
            isHideAtMenu: true,
            path: '/orderManagement/serviceOrder/tag',
            filePath: '/serviceOrder/tag.vue',
            isIframe: false,
            isIframeUrl: '',
          },
        ],
      },
      {
        index: '/orderManagement/adjustOrder',
        name: '/orderManagement/adjustOrder',
        title: '调整单',
        path: 'adjustOrder',
        filePath: '/adjustOrder/adjustOrder.vue',
        isIframe: false,
        iframeUrl: '',
      },
      {
        index: '/orderManagement/returnOrder',
        name: '/orderManagement/returnOrder',
        title: '退货单',
        path: 'returnOrder',
        filePath: '/adjustOrder/returnOrder.vue',
        isIframe: false,
        iframeUrl: '',
      },
      {
        index: '/orderManagement/penaltyOrder',
        name: '/orderManagement/penaltyOrder',
        title: '罚款单',
        path: 'penaltyOrder',
        filePath: '/adjustOrder/penaltyOrder.vue',
        isIframe: false,
        iframeUrl: '',
      },
      {
        index: '/orderManagement/contractFeeOrder',
        name: '/orderManagement/contractFeeOrder',
        title: '费用管理',
        path: 'contractFeeOrder',
        filePath: '/adjustOrder/contractFeeOrder.vue',
        isIframe: false,
        iframeUrl: '',
      },
      // {
      //   index: '/orderManagement/compensate',
      //   name: '/orderManagement/compensate',
      //   title: '进价补偿单',
      //   path: 'compensate',
      //   filePath: '/adjustOrder/compensate/index.vue',
      //   isIframe: false,
      //   iframeUrl: ''
      // },
      {
        index: '/orderManagement/compensate/compensateDetail',
        name: 'compensateDetail',
        title: '单据详情',
        path: 'compensate/compensateDetail',
        isHideAtMenu: true, // 不在左侧menu中显示
        filePath: '/adjustOrder/compensate/compensateDetail.vue',
        isIframe: false,
      },
      {
        index: '/orderManagement/compensate/applyInvoice',
        name: '/orderManagement/compensate/applyInvoice',
        title: '开票',
        isHideAtMenu: true,
        path: 'compensate/applyInvoice',
        filePath: '/adjustOrder/compensate/applyInvoice.vue',
        isIframe: false,
        iframeUrl: '',
      },
      {
        index: '/orderManagement/contractFeeOrder/apply',
        name: '/orderManagement/contractFeeOrder/apply',
        title: '申请开票',
        isHideAtMenu: true,
        path: 'contractFeeOrder/apply',
        filePath: '/adjustOrder/subPages/applyInvoice.vue',
        isIframe: false,
        iframeUrl: '',
      },
      {
        index: '/orderManagement/serviceOrder/view',
        name: '/orderManagement/serviceOrder/view',
        title: '服务费详情',
        isHideAtMenu: true,
        path: '/orderManagement/serviceOrder/view.vue',
        filePath: '/serviceOrder/view',
        isIframe: false,
        isIframeUrl: '',
      },
      {
        index: '/orderManagement/serviceOrder/serviceList',
        name: '/orderManagement/serviceOrder/serviceList',
        title: '服务费列表',
        isHideAtMenu: true,
        path: '/orderManagement/serviceOrder/serviceList.vue',
        filePath: '/serviceOrder/serviceList',
        isIframe: false,
        isIframeUrl: '',
      },
      {
        index: '/orderManagement/serviceOrder/history',
        name: '/orderManagement/serviceOrder/history',
        title: '历史数据',
        isHideAtMenu: true,
        path: '/orderManagement/serviceOrder/history',
        filePath: '/serviceOrder/history',
        isIframe: false,
        isIframeUrl: '',
      },
      {
        index: '/orderManagement/serviceOrder/historyView',
        name: '/orderManagement/serviceOrder/historyView',
        title: '历史数据详情',
        isHideAtMenu: true,
        path: '/orderManagement/serviceOrder/historyView',
        filePath: '/serviceOrder/historyView',
        isIframe: false,
        isIframeUrl: '',
      },
      {
        index: '/orderManagement/adjustOrder/invoicePlan',
        name: '/orderManagement/adjustOrder/invoicePlan',
        title: '发票申请计划',
        isHideAtMenu: true,
        path: 'adjustOrder/invoicePlan',
        filePath: '/adjustOrder/subPages/invoicePlan.vue',
        isIframe: false,
        isIframeUrl: '',
      },
      {
        index: '/orderManagement/adjustOrder/detail',
        name: '/orderManagement/adjustOrder/detail',
        title: '费用单详情',
        isHideAtMenu: true,
        path: 'adjustOrder/detail',
        filePath: '/adjustOrder/subPages/invoiceDetail.vue',
        isIframe: false,
        isIframeUrl: '',
      },
      {
        index: '/orderManagement/adjustOrder/collectFeeDetail',
        name: '/orderManagement/adjustOrder/collectFeeDetail',
        title: '揽收费明细',
        isHideAtMenu: true,
        path: 'adjustOrder/collectFeeDetail',
        filePath: '/adjustOrder/subPages/collectFeeDetail.vue',
        isIframe: false,
        isIframeUrl: '',
      },
      {
        index: '/orderManagement/serviceOrder/settlementOrder',
        name: '/orderManagement/serviceOrder/settlementOrder',
        title: '费用单详情',
        isHideAtMenu: true,
        path: '/serviceOrder/settlementOrder',
        filePath: '/serviceOrder/settlementOrder.vue',
        isIframe: false,
        isIframeUrl: '',
      },
      {
        index: '/orderManagement/postPay',
        name: '/orderManagement/postPay',
        title: '后付费费用核销管理',
        path: 'postPay',
        filePath: '/postPay/index.vue',
        isIframe: false,
        iframeUrl: '',
      },
    ],
  },
  {
    index: '5',
    name: 'invoice',
    title: '发票管理',
    path: 'invoice',
    filePath: '/iframe/index.vue',
    isIframe: false,
    iframeUrl: '',
    subPathes: [
      // {
      //   index: '5-1',
      //   name: 'invoiceMaintain',
      //   title: '维护发票',
      //   path: 'maintain',
      //   filePath: '/iframe/sub.vue',
      //   isIframe: true,
      //   iframeUrl: '/invoice/maintain'
      // },
      {
        index: '5-3',
        name: 'invoiceManage',
        title: '管理发票(新)',
        path: 'manageNew',
        isIframe: false,
        filePath: '/invoice/manage.vue',
      },
      {
        index: '5-4',
        name: 'invoiceMaintenance',
        title: '维护发票(新)',
        path: 'maintenance',
        isIframe: false,
        filePath: '/invoice/maintenance.vue',
      },
    ],
  },
  {
    index: '5.1',
    name: 'mergeInvoice',
    title: '合并开票',
    path: 'mergeInvoice',
    filePath: '/mergeInvoice/index.vue',
    isIframe: false,
    iframeUrl: '',
    subPathes: [
      {
        index: '5.1-0',
        name: 'mergeInvoiceDetail',
        title: '详情',
        path: 'mergeInvoiceDetail',
        isHideAtMenu: true, // 不在左侧menu中显示
        filePath: '/mergeInvoice/detail/index.vue',
        isIframe: false,
      },
      {
        index: '5.1-1',
        name: 'mergeInvoiceMaintainInfo',
        title: '维护发票详情',
        path: 'mergeInvoiceMaintainInfo',
        isHideAtMenu: true, // 不在左侧menu中显示
        filePath: '/mergeInvoice/maintainInfo.vue',
        isIframe: false,
      },
      {
        index: '5.1-2',
        name: 'mergeInvoicePayProgress',
        title: '付款进度',
        path: 'mergeInvoicePayProgress',
        isHideAtMenu: true, // 不在左侧menu中显示
        filePath: '/mergeInvoice/payProgress.vue',
        isIframe: false,
      },
      // 纸质发票
      {
        index: '5.1-3',
        name: 'mergeInvoiceMaintainInfoPaper',
        title: '维护发票详情',
        path: 'mergeInvoiceMaintainInfoPaper',
        isHideAtMenu: true, // 不在左侧menu中显示
        filePath: '/mergeInvoice/paper/maintainInfoPaper.vue',
        isIframe: false,
      },
      {
        index: '5.1-4',
        name: 'mergeInvoiceMaintainInfoYihai',
        title: '融合平台发票详情',
        path: 'mergeInvoiceMaintainInfoYihai',
        isHideAtMenu: true, // 不在左侧menu中显示
        filePath: '/mergeInvoice/yihai/maintainInfoYihai.vue',
        isIframe: false,
      },
      {
        index: '/mergeInvoice/create',
        name: 'createMergeInvoice',
        title: '生成发票',
        path: 'create',
        filePath: '/mergeInvoice/create.vue',
        isIframe: false,
      },
      {
        index: '/mergeInvoice/maintain',
        name: 'maintainMergeInvoice',
        title: '维护发票',
        path: 'maintain',
        isHideAtMenu: paperBoolean,
        filePath: '/mergeInvoice/maintain.vue',
        isIframe: false,
      },
      {
        index: '/mergeInvoice/maintainPaper',
        name: 'maintainMergeInvoicePaper',
        title: '维护发票',
        path: 'maintainPaper',
        isHideAtMenu: !paperBoolean, // 不在左侧menu中显示
        filePath: '/mergeInvoice/paper/maintainPaper.vue',
        isIframe: false,
      },
      {
        index: '/mergeInvoice/manage',
        name: 'manageMergeInvoice',
        title: '管理发票',
        path: 'manage',
        filePath: '/mergeInvoice/manage.vue',
        isIframe: false,
      },
      {
        index: '/mergeInvoice/maintainYihai',
        name: 'maintainMergeInvoiceYihai',
        title: '融合发票维护',
        path: 'maintainYihai',
        isHideAtMenu: !paperBoolean,
        filePath: '/mergeInvoice/yihai/maintainYihai.vue',
        isIframe: false,
      },
      {
        index: '/mergeInvoice/accountStatement',
        name: 'accountStatement',
        title: '对账单',
        path: 'accountStatement',
        filePath: '/mergeInvoice/accountStatement/index.vue',
        isIframe: false,
      },
      {
        index: '/mergeInvoice/reparation',
        name: 'reparation',
        title: '包装物买赔',
        path: 'reparation',
        filePath: '/mergeInvoice/reparation/index.vue',
        isIframe: false,
      },
      {
        index: '/mergeInvoice/accountStatement/detail',
        name: 'accountStatementDetail',
        title: '对账单详情',
        path: 'accountStatementDetail',
        filePath: '/mergeInvoice/accountStatement/detail.vue',
        isIframe: false,
        isHideAtMenu: true,
      },
    ],
  },
  {
    index: '6',
    name: 'finance',
    title: '钱包',
    path: 'finance',
    filePath: '/iframe/index.vue',
    isIframe: false,
    subPathes: [
      {
        index: '6-1',
        name: 'marketingFee',
        title: '营销费用管理',
        path: 'marketingFee',
        filePath: '/finance/marketingFee',
        isIframe: false,
      },
      {
        index: '6-2',
        name: 'selfMarketingFee',
        title: '自营营销费用管理',
        path: 'selfMarketingFee',
        filePath: '/finance/selfMarketingFee',
        isIframe: false,
      },
    ],
  },
  {
    index: '66',
    name: 'supplierConfirmLetter',
    title: '供应商对账',
    path: 'supplierConfirmLetter',
    filePath: '/iframe/index.vue',
    isIframe: false,
    subPathes: [
      {
        index: '66_1',
        name: '/supplierConfirmLetter/index',
        title: '余额确认单',
        path: 'index',
        filePath: '/supplierConfirmLetter/index.vue',
        isIframe: false,
      },
      {
        index: '66_2',
        name: '/supplierConfirmLetter/view',
        title: '余额确认单-明细',
        path: 'view',
        filePath: '/supplierConfirmLetter/view.vue',
        isIframe: false,
        isHideAtMenu: true,
      },
      {
        index: '66_3',
        name: '/supplierConfirmLetter/balance',
        title: '供应商余额表',
        path: 'index',
        filePath: '/supplierConfirmLetter/balance.vue',
        isIframe: false,
      },
    ],
  },
  // {
  //   index: '9',
  //   name: 'visit',
  //   title: '联合拜访',
  //   path: 'visit',
  //   filePath: '/visit/index.vue',
  //   isIframe: false,
  //   subPathes: [
  //     {
  //       index: '9-0',
  //       name: 'list',
  //       title: '联合拜访',
  //       path: 'list',
  //       filePath: '/visit/list.vue',
  //       isIframe: false
  //     },
  //     {
  //       index: '9-1',
  //       name: 'task',
  //       title: '分配拜访任务',
  //       path: 'task',
  //       filePath: '/visit/task.vue',
  //       isHideAtMenu: true, // 不在左侧menu中显示
  //       isIframe: false
  //     },
  //     {
  //       index: '9-2',
  //       name: 'detail',
  //       title: '拜访任务查看详情',
  //       path: 'detail',
  //       filePath: '/visit/detail.vue',
  //       isHideAtMenu: true, // 不在左侧menu中显示
  //       isIframe: false
  //     },
  //     {
  //       index: '9-3',
  //       name: 'dataBoard',
  //       title: '拜访数据',
  //       path: 'dataBoard',
  //       filePath: '/visit/dataBoard.vue',
  //       isHideAtMenu: false, // 不在左侧menu中显示
  //       isIframe: false
  //     }
  //   ]
  // },
  {
    index: '7',
    name: 'download',
    title: '下载中心',
    path: 'download',
    filePath: '/download/index.vue',
    isIframe: false,
    subPathes: [
      {
        index: '7-0',
        name: 'downloadApp',
        title: '下载中心',
        path: 'downloadApp',
        filePath: '/download/index.vue',
        isIframe: false,
      },
    ],
  },
  {
    index: '8',
    name: 'help',
    title: '帮助中心',
    path: 'help',
    filePath: '/help/index.vue',
    isIframe: false,
    subPathes: [
      {
        index: '/help/problem',
        name: 'helpIndex',
        title: '常见问题',
        path: 'problem',
        filePath: '/help/comProblem.vue',
        isIframe: false,
      },
      {
        index: '/help/feedback',
        name: 'helpFeedback',
        title: 'CEO直通车',
        path: 'feedback',
        filePath: '/help/feedback.vue',
        isIframe: false,
      },
      {
        index: '/feedbackList',
        name: '/feedbackList',
        title: '反馈列表',
        path: '/feedbackList',
        filePath: '/help/feedbackList.vue',
        isIframe: false,
        isHideAtMenu: true, // 不在左侧menu中显示
      },
    ],
  },
  // 框架协议 页面使用路由
  {
    index: '13',
    name: 'frameAgreement',
    title: '框架协议管理',
    path: 'frameAgreement',
    filePath: '/frameAgreement/index.vue',
    isIframe: false,
    isFrameAgreement: true,
    subPathes: [
      {
        index: '/frameAgreement/list',
        name: 'frameAgreementList',
        title: '框架协议',
        path: 'list',
        filePath: '/frameAgreement/list.vue',
        isIframe: false,
      },
      {
        index: '/frameAgreement/signImage',
        name: 'frameAgreementSignImage',
        title: '印章管理',
        path: 'signImage',
        filePath: '/frameAgreement/signImage.vue',
        isIframe: false,
      },
      {
        index: '/frameAgreement/sign',
        name: 'frameAgreementSign',
        title: '签署页面',
        path: 'sign',
        filePath: '/frameAgreement/sign.vue',
        isHideAtMenu: true,
        isIframe: false,
      },
      {
        index: '/frameAgreement/authorisation',
        name: 'frameAgreementAuthorisation',
        title: '授权管理',
        path: 'authorisation',
        filePath: '/contract/authorisation.vue',
        isIframe: false,
      }
    ],
  },
  {
    index: '14',
    name: 'supplierManage',
    title: '供应商管理',
    path: 'supplierManage',
    filePath: '/supplierManage/index.vue',
    isIframe: false,
    isFrameAgreement: true,
    subPathes: [
      {
        index: '/supplierManage/account',
        name: 'supplierManageAccount',
        title: '供应商账号管理',
        path: 'account',
        filePath: '/supplierManage/account.vue',
        isIframe: false,
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/router/const.js